module.exports = __webpack_public_path__ + "static/media/ic-crm-notifications.ccaf0898.svg";